import { cloneElement, createRef } from "react";
import tooltipStyles from "./tooltip.module.scss";

// type Placement =
//   | 'auto'
//   | 'auto-start'
//   | 'auto-end'
//   | 'top'
//   | 'top-start'
//   | 'top-end'
//   | 'bottom'
//   | 'bottom-start'
//   | 'bottom-end'
//   | 'right'
//   | 'right-start'
//   | 'right-end'
//   | 'left'
//   | 'left-start'
//   | 'left-end';

const Tooltip = ({
  text,
  children,
  placement,
  className = "",
  containerClassname = "",
}: any) => {
  // const [tooltipShow, setTooltipShow] = useState(false);

  const btnRef = createRef();
  const tooltipRef = createRef();
  const arrowRef = createRef();

  const openLeftTooltip = () => {
    import("@popperjs/core")
      .then((module) => {
        module.createPopper(btnRef.current, tooltipRef.current, {
          placement: placement || "bottom-end",
        });
        // setTooltipShow(true);
      });
  };

  let renderItem;

  if (children) {
    renderItem = cloneElement(children, {
      onMouseEnter: openLeftTooltip,
      ref: btnRef,
    });
  } else {
    renderItem = (
      <button
        className={`btn ${ tooltipStyles.button}`}
        type="button"
        onMouseEnter={openLeftTooltip}
        ref={btnRef}
      >

        <i className="fa fa-question-circle-o pointer" />
      </button>
    );
  }

  return (
    <>

      <div className="flex flex-wrap">

        <div className={`w-full text-left ${tooltipStyles.tooltip_wrapper}`}>
          {renderItem}

          <div
            className={`${tooltipStyles.tooltip} ${containerClassname} `}
            ref={tooltipRef}
          >

            <div>

              <div
                data-popper-arrow
                ref={arrowRef}
                className={tooltipStyles.arrow}
              />

              <div className={`text-white p-3 ${className}`}>
                {text}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Tooltip;
